import { createClient } from "@supabase/supabase-js";

// The app uses a dedicated Supabase project for the contact form edge function.
// Lovable's managed project injects VITE_SUPABASE_* env vars, so we use VITE_APP_*
// names to let deployments override the backend without affecting the preview.
export const supabase = createClient(
  import.meta.env.VITE_APP_SUPABASE_URL || "https://bsbsccjszargcweghodd.supabase.co",
  import.meta.env.VITE_APP_SUPABASE_PUBLISHABLE_KEY || "sb_publishable_EcK6rqhpQz5ewReq1opLHA_W14XYpBK"
);
